import { ComboBox, ComboBoxOption, ComboBoxProps } from '../../../cdl/ComboBox/ComboBox';

export interface TimeZoneSelectProps extends Omit<ComboBoxProps<ComboBoxOption>, 'onChange' | 'value' | 'options'> {
    timeZoneId: string;
    onChange: (option: string) => void;
}

const timeZoneNames = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : [];

export function TimeZoneSelect({ timeZoneId, onChange, ...props }: TimeZoneSelectProps) {
    const options = timeZoneNames.map((name) => ({ value: name, label: name }));

    return (
        <ComboBox {...props} value={timeZoneId} options={options} onChange={(timeZone) => onChange(timeZone ?? '')} />
    );
}
